import {Form, InputNumber, Typography} from "antd";
import React, {useEffect, useRef} from "react";

export default function BridgeParameters({br, onValuesChange, params}) {
    const formRef = useRef()

    const processParameters = (parameters) => {
        if(!parameters)
            return {}

        return parameters
    }

    useEffect(() => {
        formRef.current.setFieldsValue({
            ...processParameters((params || br?.dict?.data))
        })
    }, [params, br])

    return (
        <>
            <Form
                ref={formRef}
                initialValues={{...processParameters((params || br?.dict?.data))}}
                onFieldsChange={(e) => {
                    onValuesChange && onValuesChange(formRef.current.getFieldsValue())
                }}
                style={{marginBottom: 24}}
            >
                <div style={{display: 'flex', gap: 24}}>
                    <div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Distance (US):
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'dist_us'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Width:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'width'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Rail Station Tol:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'rail_station'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Rail US Left:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'rail_ul'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Rail US Right:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'rail_ur'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Rail DS Left:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'rail_dl'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Rail DS Right:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'rail_dr'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Distance (DS):
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'dist_ds'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <Typography.Text style={{width: 125}}>
                                Skew:
                            </Typography.Text>
                            <Form.Item
                                style={{padding: 0, margin: 0}}
                                name={'deck_skew'}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </div>
                    </div>
                    <div>
                        <table>
                            <tr>
                                <td></td>
                                <td>US</td>
                                <td>DS</td>
                            </tr>
                            {
                                br?.dict?.data['pier_widths'].map((pw, idx) => {
                                    return (
                                        <tr>
                                            <td>
                                                <Typography.Text style={{width: 125, marginRight: 8}}>
                                                    Pier #{idx + 1} Width:
                                                </Typography.Text>
                                            </td>
                                            <td>
                                                <Form.Item
                                                    style={{padding: 0, margin: 0}}
                                                    name={`${pw}_width_us`}
                                                >
                                                    <InputNumber/>
                                                </Form.Item>
                                            </td>
                                            <td>
                                                <Form.Item
                                                    style={{padding: 0, margin: 0}}
                                                    name={`${pw}_width_ds`}
                                                >
                                                    <InputNumber/>
                                                </Form.Item>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </div>
                </div>
            </Form>
        </>
    )
}